export default __webpack_public_path__ + "static/media/mn-fotor-bg-remover-20230704234138.80acb764.png";